
import { defineComponent, ref, onMounted, computed } from "vue";

import { store } from "@/store";

import ToolTitle from "./ToolTitle.vue";

import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "Rotate",
  components: {
    ToolTitle,
  },
  setup() {
    const title = ref("");

    const landscape = ref<HTMLDivElement>();
    const portrait = ref<HTMLDivElement>();

    const displayOrientation = ref("");
    const getDefaultOrientation = computed<string>(() =>
      store.getters.currentLabel.width >= store.getters.currentLabel.height
        ? "Landscape"
        : "Portrait"
    );
    const isRotated = computed<boolean>(() =>
      store.getters.canvasOrientation === "rotated" ? true : false
    );
    onMounted(() => {
      if (isRotated.value) {
        if (getDefaultOrientation.value === "Landscape") {
          if (portrait.value) {
            portrait.value.style.backgroundColor = "#838591";
            displayOrientation.value = "Portrait";
          }
        } else {
          if (landscape.value) {
            landscape.value.style.backgroundColor = "#838591";
            displayOrientation.value = "Landscape";
          }
        }
      } else {
        if (getDefaultOrientation.value === "Landscape") {
          if (landscape.value) {
            landscape.value.style.backgroundColor = "#838591";
            displayOrientation.value = "Landscape";
          }
        } else {
          if (portrait.value) {
            portrait.value.style.backgroundColor = "#838591";
            displayOrientation.value = "Portrait";
          }
        }
      }

      title.value = "Rotate Canvas";
    });

    const rotateOrientation = computed<string>(() =>
      store.getters.canvasOrientation === "default" ? "rotated" : "default"
    );
    const choseOrientation = async (orientation: string): Promise<void> => {
      if (orientation !== displayOrientation.value) {
        await store.dispatch(ActionTypes.SET_CANVAS_ORIENTATION, rotateOrientation.value);

        displayOrientation.value = orientation;

        if (orientation === "Landscape") {
          if (landscape.value) {
            landscape.value.style.backgroundColor = "#838591";
          }

          if (portrait.value) {
            portrait.value.style.backgroundColor = "";
          }
        } else {
          if (portrait.value) {
            portrait.value.style.backgroundColor = "#838591";
          }

          if (landscape.value) {
            landscape.value.style.backgroundColor = "";
          }
        }
      }
    };

    return {
      title,
      landscape,
      portrait,
      choseOrientation,
    };
  },
});
